export default class ControlMessage{constructor(t){this.triggerId=t}static fromJson(t){return new ControlMessage(t.trigger_id)}}